import { jsx as i, jsxs as m } from "react/jsx-runtime";
import { B as y } from "./brand-logo-gXVHIcw3.mjs";
import { c as s } from "./tw-cn-mXgPecoF.mjs";
import { I as w } from "./icon-button-LzZMa7lf.mjs";
const f = ({ children: a, href: t, className: o, onClick: e }) => t ? /* @__PURE__ */ i("a", { className: o, href: t, onClick: e, children: a }) : /* @__PURE__ */ i("div", { className: o, onClick: e, role: "button", tabIndex: 0, children: a }), x = ({
  button: a,
  badge: t,
  className: o,
  pcType: e = "pcSize",
  theme: n = "ghost"
}) => {
  const c = e === "pcSize";
  return /* @__PURE__ */ m(f, { className: s("relative cursor-pointer", o), href: a.href, onClick: a.onClick, children: [
    /* @__PURE__ */ i(
      w,
      {
        "aria-label": a["aria-label"],
        icon: a.icon,
        size: c ? void 0 : "medium",
        theme: n
      }
    ),
    t
  ] });
}, N = 6, v = ({ item: a, pcType: t = "pcSize", transparent: o }) => {
  const { button: e, text: n } = a, c = n == null ? void 0 : n.substring(0, N), d = t === "pcSize";
  return e.href ? /* @__PURE__ */ i(
    "a",
    {
      className: s("w-84 whitespace-nowrap pr-10 text-right typography-body-14-bold", {
        "pc:typography-subtitle-16-bold": d,
        "text-static-white": o
      }),
      href: e.href,
      onClick: e.onClick,
      children: c
    }
  ) : /* @__PURE__ */ i(
    "button",
    {
      className: s("w-84 whitespace-nowrap pr-10 text-right typography-body-14-bold", {
        "pc:typography-subtitle-16-bold": d,
        "text-static-white": o
      }),
      onClick: e.onClick,
      onKeyDown: (h) => {
        (h.key === "Enter" || h.key === " ") && e.onClick();
      },
      type: "button",
      children: c
    }
  );
}, u = ({
  title: a = "",
  leftButton: t,
  rightButtons: o,
  children: e,
  pcType: n = "pcSize",
  theme: c,
  className: d
}) => {
  const h = t !== void 0, g = o && o.length > 0, r = n === "pcSize", p = c === "transparent";
  return /* @__PURE__ */ m(
    "div",
    {
      className: s(
        "flex min-h-52 flex-row items-center gap-8 bg-static-white px-10 py-4 align-middle",
        {
          "pc:min-h-76 pc:gap-16 pc:px-20": r,
          "pl-20 pc:pl-40": !h,
          "pr-20 pc:pr-40": !g,
          "bg-transparent": p || c === "ghost"
        },
        d
      ),
      children: [
        /* @__PURE__ */ m("div", { className: s("flex w-full min-w-0 flex-wrap items-center gap-0", { "pc:gap-16": r }), children: [
          !!h && /* @__PURE__ */ i("div", { className: s("flex items-center gap-4", { "pc:gap-0": r }), children: t.useNolLogo ? /* @__PURE__ */ i(
            f,
            {
              className: s("inline-flex items-center p-10", {
                "pc:px-20 pc:py-12 pc:pr-4": r
              }),
              href: t.href,
              onClick: t.onClick,
              children: /* @__PURE__ */ i(
                y,
                {
                  "aria-label": t["aria-label"] || "NOL 로고",
                  className: s("h-17", {
                    "pc:h-23": r
                  }),
                  theme: p ? "white" : "brand"
                }
              )
            }
          ) : /* @__PURE__ */ i(
            x,
            {
              button: t,
              pcType: n,
              theme: p ? "transparent" : "ghost"
            }
          ) }),
          /* @__PURE__ */ i(
            "div",
            {
              className: s("w-full flex-1 overflow-hidden text-left typography-subtitle-18-bold", {
                "pc:typography-headline-24-bold": r,
                "line-clamp-1": !!a && !e,
                "text-static-white": p
              }),
              children: e || a
            }
          )
        ] }),
        !!g && /* @__PURE__ */ i("div", { className: "flex", children: o.map(
          (l, b) => l.type === "Icon" ? /* @__PURE__ */ i(
            x,
            {
              badge: l.badge,
              button: l.button,
              pcType: n,
              theme: p ? "transparent" : "ghost"
            },
            `${l.button["aria-label"]}_${b.toString()}`
          ) : /* @__PURE__ */ i(
            v,
            {
              item: l,
              pcType: n,
              transparent: p
            },
            `${l.text}_${b.toString()}`
          )
        ) })
      ]
    }
  );
};
u.displayName = "NDS.TopNavigation";
export {
  u as T,
  x as a,
  v as b
};
